<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
      <div class="d-block mb-4 mb-md-0">
        <h2 class="h4">{{ $t("categories.allCategories") }}</h2>
        <p class="mb-0">{{ $t("categories.allCategoryDetail") }}</p>
      </div>
    </div>
    <data-table :callback="getCategoriesData" ajax :columns="columns" :actions="actions"></data-table>
  </div>
</template>

<script>
import { productService } from '../services/product.service.js';

export default {
  data() {
    return {
      columns: [
        { name: 'code', th: this.$t('categories.code') },
        { name: 'name', th: this.$t('categories.name') },
      ],
      actions: [
        {
          text: this.$t('categories.showProducts'),
          color: 'success',
          size: 'sm',
          action: (row) => {
            this.showProducts(row.code);
          },
        },
      ],
    };
  },
  methods: {
    showProducts(categoryCode) {
      this.$router.push({ path: `categories/${categoryCode}/products` });
    },
    async getCategoriesData(params) {
      return await productService.getAllCategories(params);
    },
  },
};
</script>
